var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowerBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 98,
    viewBox: "0 0 82 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2490_1282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9203 31.1538C72.9105 -10.3846 8.90766 -10.3846 32.8979 31.1538C8.90766 -10.3846 -23.1371 45 24.93 45C-23.0505 45 8.90766 100.385 32.8979 58.8462C8.90766 100.385 72.9105 100.385 48.9203 58.8462C72.9105 100.385 104.955 45 56.8881 45C104.955 45 72.9105 -10.3846 48.9203 31.1538Z",
    fill: "#6CC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9203 31.1538L49.7862 31.654C55.7016 21.4116 61.9733 17.385 67.1602 16.7867C72.3319 16.1901 76.7269 18.9637 79.0599 23.0004C81.3929 27.0369 81.599 32.2235 78.4928 36.3983C75.3768 40.5862 68.7418 44 56.8881 44V45V46C68.7418 46 75.3768 49.4138 78.4928 53.6017C81.599 57.7765 81.3929 62.9631 79.0599 66.9996C76.7269 71.0363 72.3319 73.8099 67.1602 73.2133C61.9733 72.615 55.7016 68.5884 49.7862 58.346L48.9203 58.8462L48.0543 59.3463C53.9699 69.5889 54.3219 77.0282 52.2466 81.8137C50.1774 86.585 45.5764 89 40.9091 89C36.2418 89 31.6408 86.585 29.5716 81.8137C27.4962 77.0282 27.8483 69.5889 33.7639 59.3463L32.8979 58.8462L32.032 58.346C26.1163 68.5889 19.8499 72.6151 14.6701 73.2133C9.50595 73.8097 5.11916 71.037 2.79121 67.0004C0.463278 62.9638 0.25944 57.7765 3.36224 53.6013C6.47444 49.4134 13.0987 46 24.93 46V45V44C13.0764 44 6.44137 40.5862 3.32536 36.3983C0.219197 32.2235 0.42532 27.0369 2.75826 23.0004C5.0913 18.9637 9.48631 16.1901 14.658 16.7867C19.8449 17.385 26.1165 21.4116 32.032 31.654L32.8979 31.1538L33.7639 30.6537C27.8483 20.4111 27.4962 12.9718 29.5716 8.18633C31.6408 3.41505 36.2418 0.999999 40.9091 0.999999C45.5764 0.999999 50.1774 3.41505 52.2466 8.18633C54.3219 12.9718 53.9699 20.4111 48.0543 30.6537L48.9203 31.1538Z",
    stroke: "#1C1616",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2490_1282",
    x: 0,
    y: 0,
    width: 81.8184,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2490_1282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2490_1282",
    result: "effect2_dropShadow_2490_1282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2490_1282",
    result: "effect3_dropShadow_2490_1282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2490_1282",
    result: "effect4_dropShadow_2490_1282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2490_1282",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerBlue);
export default __webpack_public_path__ + "static/media/flower-blue.afaedd67.svg";
export { ForwardRef as ReactComponent };